export default __webpack_public_path__ + "static/media/bg_smll_03.6abcc1aa.png";